import { apiClient } from "./client";
import { GeoPrecisione } from "./clients";

export type TipoPuntoMappa = "installazione" | "sopralluogo" | "intervento" | "attivazione";

/**
 * Un punto disegnabile sulla mappa multi-livello. Sopralluoghi, interventi e
 * attivazioni non hanno coordinate proprie: le ereditano dalla sede collegata
 * (`sede_id`), geocodificata una volta per tutti e tre.
 *
 * Chi non ha una posizione semplicemente non arriva qui — non è un errore, e
 * resta visibile ovunque il resto dell'app già lo mostri.
 */
export interface PuntoMappa {
  id: string;
  tipo: TipoPuntoMappa;
  titolo: string;
  /** Numeri veri, non stringhe: la conversione la fa il backend (vedi routes/mappa.ts). */
  lat: number;
  lng: number;
  /**
   * `indirizzo` = il punto sta dove sta la sede.
   * `comune` = l'indirizzo non era risolvibile e si è ripiegato sul centro del
   * paese, quindi può essere lontano chilometri. In produzione riguarda circa
   * un terzo delle sedi, ed è il motivo per cui la mappa lo disegna diverso.
   */
  precisione: GeoPrecisione;
  stato: string | null;
  data: string | null;
  cliente: string | null;
  cliente_id: string | null;
  sede_id: string | null;
  sede_nome: string | null;
  provincia: string | null;
}

/** @param tipi sottoinsieme di tipi da caricare; omesso, li restituisce tutti. */
export async function listPuntiMappa(tipi?: TipoPuntoMappa[]): Promise<{ punti: PuntoMappa[] }> {
  const { data } = await apiClient.get<{ punti: PuntoMappa[] }>("/mappa", {
    params: tipi?.length ? { tipi: tipi.join(",") } : undefined,
  });
  return data;
}
